import { ICreatedDate, ILimitSkipSort } from "src/app/globals/globals";
import { CommonStatusType } from "src/app/globals/custom-types/global-custom-types";
import { AllLocaleWithChild, Locale, LocaleType } from "../../locale/models/locale";
import UnitType from "../../unit-type/models/unit-type";
import Unit from "../../unit/models.ts/unit";
import { TrackerDependencyType } from "../enums/tracker-dependency-type";
import Formula, { CalculationType } from "./formula";
import { TrackingRightUserType } from "./tracker";
import TrackerTag from "./tracker-tag";
import TrackerType from "./tracker-type";

export default class TrackerApiModel {
    _id: string;
    calculation?: CalculationType;
    commonNutrition?: string;
    currentYearTimeBin: number;
    depend: TrackerDependencyType;
    dependsId?: string[];
    dependsOnTrackers?: TrackerApiModel[];
    dependsOnMe?: string[];
    dependsOnMeTrackers?: TrackerApiModel[]
    description?: string;
    formula?: Partial<Formula> | Partial<Formula>[] ;
    formulaId?: string;
    image?: string;
    inputOption?: {min: number, max: number, move: number};
    isDefaultTracker?: boolean;
    isSystemTracker?: boolean;
    localeId?: LocaleType;
    locales?: Locale[];
    memberId?: string;
    shortDescription?: string;
    status?: CommonStatusType;
    template?: string;
    trackerChartAttr?: ITrackerChartAPIData;
    publishEndDate?: Date;
    trackerName?: string;
    trackingRight?: TrackingRightUserType;
    publishStartDate?: Date;
    trackerTag?: TrackerTag[] | string[];
    trackerType?: Partial<TrackerType> | string;
    trackerTypeId?: string;
    unit?: Partial<Unit>;
    unitId?: string;
    unitType?: UnitType;
    unitTypeId?: string;
    updateInterval?: number
    updateIntervalCustomYearsCount?: number;

    constructor() {
        this.localeId = new AllLocaleWithChild()
    }
}

export interface ITrackerChartAPIData {
    chartBackColor: string
    chartBackImg?: string
    chartSeriesColor: string,
    chartType: string,
}

export interface ITrackerQuery extends Partial<TrackerApiModel>,ILimitSkipSort {
    limit?: number;
    skip?: number;
    locale?: string | string[];
    status?:CommonStatusType
    createdDate?: Date | ICreatedDate;
    isBrowseTrackerRequested?: boolean;
}